import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import { ICustomer } from '../../store/ducks/customers/types';
import CustomersFilter from './CustomersFilter';
import CustomersTable from './CustomersTable';
import {
  Container,
  ContractsAndConstructionsHomeHeader,
  CustomersTableContainer
} from './styles';
import { Title } from '@gerdau/hefesto/Title';
import { sendTagging } from '../../store/ducks/tagging/actions';

const AccessManagement: React.FC = () => {
  const userState = useSelector((state: ApplicationState) => state.user);
  const dispatch = useDispatch();

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );

  const customers = useSelector((state: ApplicationState) =>
    userState.isManager
      ? state.customers.customers
      : state.customers.customers.filter((customer) =>
          userState.roles.adminCustomers.includes(customer.customerId)
        )
  );

  const [filteredCustomers, setFilteredCustomers] = useState<
    ICustomer[] | undefined
  >(undefined);

  const initFilteredCustomers = () => {
    if (
      !customersState.loading &&
      customers.length > 0 &&
      filteredCustomers === undefined
    ) {
      setFilteredCustomers(customers);
    }
  };

  useEffect(() => {
    initFilteredCustomers();
  });

  useEffect(() => {
    dispatch(
      sendTagging({
        page: window.location.pathname,
        screenName: 'LG:GestaoDeUsuarios',
        event: 'page_view'
      })
    );
  }, []);

  return (
    <>
      <ContractsAndConstructionsHomeHeader>
        <Title level={1}>Gestão de usuários</Title>
        <span className="description-facelift">
          Faça a gestão dos usuários da sua conta, adicionando e editando as
          permissões dos usuários.
        </span>
      </ContractsAndConstructionsHomeHeader>

      <Container>
        <div className="content">
          <CustomersFilter
            customers={customers}
            onFilter={setFilteredCustomers}
            isManager={userState.isManager}
            customersState={customersState}
          />

          <CustomersTableContainer>
            {(customersState.loading || customersState.loadingCustomerById) &&
              customers.length === 0 && (
                <Skeleton count={6} style={{ margin: '0.5rem 0' }} />
              )}

            {!customersState.loading && filteredCustomers && (
              <CustomersTable
                customers={userState.isManager ? customers : filteredCustomers}
              />
            )}
          </CustomersTableContainer>
        </div>
      </Container>
    </>
  );
};

export default AccessManagement;
